export default class ModelBase 
{
     descripcion:string ="";
     estado:boolean = true;
}